<template>
    <v-container v-if="this.currentUser" fluid class="container">
        <v-img width="200px" contain :src="require('@/assets/profile.png')" />
        <div class="name">
            {{ this.currentUser.firstName }}  {{ this.currentUser.lastName }}
        </div>
        <div class="roles-wrapper">
            <span>Δικαιώματα:</span>
            <v-chip-group
                active-class="primary--text"
                class = "group-chips"
            >
                <v-chip
                    v-for="role in this.currentUser.roles"
                    :key="role.role"
                    :color="getRoleColor(role.role)"
                    class="role-chip"
                    disabled
                >
                    {{ getRoleText(role.role) }}
                </v-chip>
            </v-chip-group>
        </div>
    </v-container>
</template>
<script>
    import user from '@/services/user'
    import userMixin from '@/mixins/user'
    export default {
        data() {
            return {
                currentUser: null
            }
        },
        created() {
            this.getCurrentUser()
        },
        mixins: [ userMixin ],
        methods: {
            getCurrentUser() {
                user.getCurrentUser().then(resp => {
                    this.currentUser = resp.data
                })
            }
        }
    }
</script>
<style scoped>
.container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-top: 8%;
    color: var(--cards-and-tables-text-color);
}

.name {
    font-weight: bold;
    font-size: calc(1vw + 2vh);
}

.role-chip {
    color: white;
}

.v-chip--disabled {
    opacity: 1;
}

.roles-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
}

</style>
